import { ChevronLeft, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import type { DeviceStatus } from '@/lib/types';

interface Props {
  device: DeviceStatus;
  onOpenSettings: () => void;
  canOpenSettings: boolean;
}

export function DeviceHero({ device, onOpenSettings, canOpenSettings }: Props) {
  const online = !!device.online;
  const name = device.clientName || device.client_name;
  return (
    <div className="mb-5">
      <Link to="/devices" className="inline-flex items-center text-sm text-slate-500 hover:text-ink mb-3 group">
        <ChevronLeft className="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" />
        Back to devices
      </Link>
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-2xl font-extrabold text-ink tracking-tight truncate">{name}</h1>
          <div className="flex items-center gap-2 mt-1.5">
            <Badge tone={online ? 'ok' : 'neutral'} dot>{online ? 'Online' : 'Offline'}</Badge>
            <span className="text-xs text-slate-500 font-mono">{device.client_id}</span>
            {device.configError && <Badge tone="bad" dot>Config error</Badge>}
            {device.configured === false && <Badge tone="warn" dot>Setup required</Badge>}
          </div>
        </div>
        {canOpenSettings && (
          <Button variant="outline" onClick={onOpenSettings}>
            <Settings className="w-4 h-4" />
            Settings
          </Button>
        )}
      </div>
    </div>
  );
}
